export default {
  day: '天',
  freeTimesLimitTitle: '免費賬號的試用今天已用完。',
  fileSizeLimitTitle: '免費賬號的檔案大小不能超過20MB。',
  total: '全部的',
  enterCode: '輸入碼',
  signUpToPurchaseBtn: '註冊並去購買',
  goPurchseBtn: '去購買',
  saveTips: '最多可節省{{num}}%',
  discount: '折扣',
  montly: '每月',
  yearly: '每年的',
  weekly: '每週',
  week: '週',
  priceWeek: 'NT$320',
  priceMonth: 'NT$240',
  priceYearly: 'NT$120',
  billMonth: 'NT$959 月度訂閱費用',
  billYear: 'NT$5799 年度訂閱費用',
  AlreadySubscribe: '已經訂閱？',
  vipTips1: '沒有檔案大小限制',
  vipTips2: '處理檔案數量無限制',
  vipTips3: '無限制地更改影象背景',
  vipTips4: '使用所有免費工具和高階功能',
  purchaseTips: '自動續訂並隨時取消。',
  tips: '提示：',
  promoCodeInvalidTips: '你的優惠碼無效',
};
